// _actions.js

import * as types from './_actionTypes';

export const fetchAvailableCoursesRequest = (userId) => ({
  type: types.FETCH_AVAILABLE_COURSES_REQUEST,
  payload: userId
});

export const fetchAvailableCoursesSuccess = (data) => ({
  type: types.FETCH_AVAILABLE_COURSES_SUCCESS,
  payload: data
});

export const fetchAvailableCoursesFailure = (error) => ({
  type: types.FETCH_AVAILABLE_COURSES_FAILURE,
  payload: error
});

export const fetchEnrolledCoursesRequest = () => ({
  type: types.FETCH_ENROLLED_COURSES_REQUEST
});

export const fetchEnrolledCoursesSuccess = (data) => ({
  type: types.FETCH_ENROLLED_COURSES_SUCCESS,
  payload: data
});

export const fetchEnrolledCoursesFailure = (error) => ({
  type: types.FETCH_ENROLLED_COURSES_FAILURE,
  payload: error
});

// Enroll Course Actions
export const enrollCourseRequest = (data) => ({
  type: types.ENROLL_COURSE_REQUEST,
  payload: data
});

export const enrollCourseSuccess = (data) => ({
  type: types.ENROLL_COURSE_SUCCESS,
  payload: data
});

export const enrollCourseFailure = (error) => ({
  type: types.ENROLL_COURSE_FAILURE,
  payload: error
});

// Unenroll Course Actions
export const unenrollCourseRequest = (data) => ({
  type: types.UNENROLL_COURSE_REQUEST,
  payload: data
});

export const unenrollCourseSuccess = (data) => ({
  type: types.UNENROLL_COURSE_SUCCESS,
  payload: data
});

export const unenrollCourseFailure = (error) => ({
  type: types.UNENROLL_COURSE_FAILURE,
  payload: error
});

// Clear Message Action
export const clearEnrollmentMessage = () => ({
  type: types.CLEAR_ENROLLMENT_MESSAGE
});

// Clear Course Content Action - clears all content data when switching courses
export const clearCourseContent = () => ({
  type: types.CLEAR_COURSE_CONTENT
});

export const updateVideoProgress = (videoId, progress) => ({
  type: types.UPDATE_VIDEO_PROGRESS,
  payload: { videoId, progress }
});

export const completeVideo = (videoId) => ({
  type: types.COMPLETE_VIDEO,
  payload: videoId
});

// Student Course Contents Actions
export const fetchStudentCourseContentsRequest = (courseId, filters = {}) => ({
  type: types.FETCH_STUDENT_COURSE_CONTENTS_REQUEST,
  payload: { courseId, filters }
});

export const fetchStudentCourseContentsSuccess = (contents) => ({
  type: types.FETCH_STUDENT_COURSE_CONTENTS_SUCCESS,
  payload: { contents }
});

export const fetchStudentCourseContentsFailure = (error) => ({
  type: types.FETCH_STUDENT_COURSE_CONTENTS_FAILURE,
  payload: { error }
});

// Student Fetch Content Stats Actions
export const fetchStudentContentStatsRequest = (courseId) => ({
  type: types.FETCH_STUDENT_CONTENT_STATS_REQUEST,
  payload: { courseId }
});

export const fetchStudentContentStatsSuccess = (stats) => ({
  type: types.FETCH_STUDENT_CONTENT_STATS_SUCCESS,
  payload: { stats }
});

export const fetchStudentContentStatsFailure = (error) => ({
  type: types.FETCH_STUDENT_CONTENT_STATS_FAILURE,
  payload: { error }
});

// Student Fetch Content By ID Actions
export const fetchStudentContentByIdRequest = (contentId) => ({
  type: types.FETCH_STUDENT_CONTENT_BY_ID_REQUEST,
  payload: { contentId }
});

export const fetchStudentContentByIdSuccess = (content) => ({
  type: types.FETCH_STUDENT_CONTENT_BY_ID_SUCCESS,
  payload: { content }
});

export const fetchStudentContentByIdFailure = (error) => ({
  type: types.FETCH_STUDENT_CONTENT_BY_ID_FAILURE,
  payload: { error }
});

// Student Update Content Progress Actions
export const updateStudentContentProgressRequest = (contentId, progressData) => ({
  type: types.UPDATE_STUDENT_CONTENT_PROGRESS_REQUEST,
  payload: { contentId, progressData }
});

export const updateStudentContentProgressSuccess = (contentId, progress) => ({
  type: types.UPDATE_STUDENT_CONTENT_PROGRESS_SUCCESS,
  payload: { contentId, progress }
});

export const updateStudentContentProgressFailure = (error) => ({
  type: types.UPDATE_STUDENT_CONTENT_PROGRESS_FAILURE,
  payload: { error }
});

// Student Mark Content Complete Actions
export const markStudentContentCompleteRequest = (contentId) => ({
  type: types.MARK_STUDENT_CONTENT_COMPLETE_REQUEST,
  payload: { contentId }
});

export const markStudentContentCompleteSuccess = (contentId) => ({
  type: types.MARK_STUDENT_CONTENT_COMPLETE_SUCCESS,
  payload: { contentId }
});

export const markStudentContentCompleteFailure = (error) => ({
  type: types.MARK_STUDENT_CONTENT_COMPLETE_FAILURE,
  payload: { error }
});

// Student Fetch Next Content Actions
export const fetchStudentNextContentRequest = (courseId) => ({
  type: types.FETCH_STUDENT_NEXT_CONTENT_REQUEST,
  payload: { courseId }
});

export const fetchStudentNextContentSuccess = (content) => ({
  type: types.FETCH_STUDENT_NEXT_CONTENT_SUCCESS,
  payload: { content }
});

export const fetchStudentNextContentFailure = (error) => ({
  type: types.FETCH_STUDENT_NEXT_CONTENT_FAILURE,
  payload: { error }
});